import { httpClient, HttpMethod } from './http-client';
import {
  OutcomeReason,
  OutcomeReview,
  SLAConfigData,
  SLARuleType,
  SLAScope,
  SLATargetType,
  SLATimerType,
  SLAConfigMetaDataResponse,
  SLADateUpdate,
} from '../@types/sla.type';
import { SLAContactRowData } from '../components/organisms/SLAContactRow';

export const getAllSLAScopes = (): Promise<SLAScope[]> => {
  return httpClient<SLAScope[]>('/scopes', HttpMethod.Get);
};

export const getAllSLATimerTypes = (): Promise<SLATimerType[]> => {
  return httpClient<SLATimerType[]>('/timerTypes', HttpMethod.Get);
};

export const getAllSLAConfigs = (): Promise<SLAConfigData[]> => {
  return httpClient<SLAConfigData[]>('/slaConfigs', HttpMethod.Get);
};

export const createSLAConfig = (slaTemplate: Partial<SLARuleType>): Promise<SLAConfigData> => {
  return httpClient<SLAConfigData>('/configs', HttpMethod.Post, slaTemplate);
};

export const updateSLAConfig = (
  id: number,
  slaTemplate: Partial<SLARuleType>
): Promise<SLAConfigData> => {
  return httpClient<SLAConfigData>(`/configs/${id}`, HttpMethod.Put, slaTemplate);
};

export const getAllSLATargetTypes = (): Promise<SLATargetType[]> => {
  return httpClient<SLATargetType[]>('/targetTypes', HttpMethod.Get);
};

export const getSLAsByServiceId = (serviceId: number): Promise<SLAContactRowData[]> => {
  return httpClient<SLAContactRowData[]>(`/services/${serviceId}/slas`, HttpMethod.Get);
};

export const getAllOutcomeReasons = (): Promise<OutcomeReason[]> => {
  return httpClient<OutcomeReason[]>('/outcomeReason', HttpMethod.Get);
};

export const createOutcomeReview = (
  serviceId: number,
  outcomeReview: Omit<OutcomeReview, 'id'> & { id?: number }
): Promise<void> => {
  return httpClient<void>(`/outcomeReview/${serviceId}`, HttpMethod.Post, outcomeReview);
};

export const updateSLATimeoutAt = (id: number, data: SLADateUpdate): Promise<void> => {
  return httpClient<void>(`/sla/date/${id}`, HttpMethod.Put, data);
};

export const resetSLAsByServiceId = (serviceId: number): Promise<void> => {
  return httpClient<void>(`/services/${serviceId}/slas`, HttpMethod.Delete);
};

export const resetSLAById = (slaId: number): Promise<void> => {
  return httpClient<void>(`/slas/${slaId}`, HttpMethod.Delete);
};

export const refreshSLAsByServiceId = (serviceId: number): Promise<void> => {
  return httpClient<void>(`/slas/refresh/service/${serviceId}`, HttpMethod.Put);
};

export const getSLAConfigMetaData = (): Promise<SLAConfigMetaDataResponse> => {
  return httpClient<SLAConfigMetaDataResponse>('/slaConfigMetaData', HttpMethod.Get);
};
